__turbopack_context__.v({
  "button": "BoutiqueCard-module-scss-module__o92BUa__button",
  "card": "BoutiqueCard-module-scss-module__o92BUa__card",
  "ctas": "BoutiqueCard-module-scss-module__o92BUa__ctas",
  "details": "BoutiqueCard-module-scss-module__o92BUa__details",
  "icon": "BoutiqueCard-module-scss-module__o92BUa__icon",
  "image": "BoutiqueCard-module-scss-module__o92BUa__image",
  "imagePlaceholder": "BoutiqueCard-module-scss-module__o92BUa__imagePlaceholder",
  "imageWrapper": "BoutiqueCard-module-scss-module__o92BUa__imageWrapper",
  "info": "BoutiqueCard-module-scss-module__o92BUa__info",
  "links": "BoutiqueCard-module-scss-module__o92BUa__links",
  "name": "BoutiqueCard-module-scss-module__o92BUa__name",
  "row": "BoutiqueCard-module-scss-module__o92BUa__row",
  "text": "BoutiqueCard-module-scss-module__o92BUa__text",
  "textLink": "BoutiqueCard-module-scss-module__o92BUa__textLink",
});
